import React from "react";

const Navigation = ({ currentView, setCurrentView, setShowAlphaGalModal }) => {
  return (
    <nav className="nav">
      <button
        className={`nav-btn ${currentView === "detective" ? "active" : ""}`}
        onClick={() => setCurrentView("detective")}
      >
        🔍 Food Detective
      </button>
      <button
        className={`nav-btn ${currentView === "history" ? "active" : ""}`}
        onClick={() => setCurrentView("history")}
      >
        📋 My History
      </button>
      <button
        className={`nav-btn ${currentView === "kitchen" ? "active" : ""}`}
        onClick={() => setCurrentView("kitchen")}
      >
        🍳 Dana's Kitchen
      </button>
      <button className="nav-btn" onClick={() => setShowAlphaGalModal(true)}>
        ℹ️ About Alpha-Gal
      </button>
    </nav>
  );
};

export default Navigation;
